var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{ref:"avatar",attrs:{"src":_vm.userAvatar}})
}
var staticRenderFns = []

export { render, staticRenderFns }